import { Component, OnInit } from '@angular/core';
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import { NewStoryService } from '../new/new.service';

@Component({
  selector: 'photosPopup',
  styleUrls: ['./photosPopup.component.scss'],
  templateUrl: './photosPopup.component.html',
  animations: [
    trigger('fadeInAnimation', [
      state(
        'hidden',
        style({
          display: 'none',
          opacity: 0,
          margin: '0',
        })
      ),
      state(
        'shown',
        style({
          display: 'block',
          opacity: 1,
          margin: '77px 0',
        })
      ),
      transition('hidden => shown', animate('300ms ease-in')),
      transition('shown => hidden', animate('300ms ease-in')),
    ]),
  ],
})
export class PhotosPopupComponent implements OnInit {
  public animationState = 'hidden';
  public albums = [];

  constructor(public uploadService: NewStoryService) {
    this.albums = this.uploadService.getAlbums();
  }

  public ngOnInit() {
    setTimeout(() => (this.animationState = 'shown'), 0);
  }

  public closeModal() {
    this.animationState = 'hidden';
    setTimeout(() => this.uploadService.unsetAlbums(), 300);
  }
}
